import React, { useRef, useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import CheckCircle from "@mui/icons-material/CheckCircle";
import DnsIcon from "@mui/icons-material/Dns";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Helmet } from "react-helmet";
import "../css/nameserver.css";

function NameServer() {
  const [data, setData] = useState();
  const [alertMsg, setAlertMsg] = useState("");
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [tickServerName, setTickServerName] = useState(false);
  const [tickIpName, setTickIpName] = useState(false);
  const [tickHostName, setTickHostName] = useState(false);
  const [nameserver1Name, setnameserver1Name] = useState(false);
  const [nameserver2Name, setnameserver2Name] = useState(false);
  const [nameserver3Name, setnameserver3Name] = useState(false);
  const [nameserver4Name, setnameserver4Name] = useState(false);
  const scrollToElementRef = useRef(null);

  const serverNameRef = useRef(null);
  const ipRef = useRef(null);
  const hostnameRef = useRef(null);
  const nameserver1Ref = useRef(null);
  const nameserver2Ref = useRef(null);
  const nameserver3Ref = useRef(null);
  const nameserver4Ref = useRef(null);
  console.log(data);
  
  const showToast = (message) => {
    console.log("Showing toast:", message); // Debug log
    setToastMessage(message);
    setTimeout(() => {
      setToastMessage("");
    }, 3000);
  };
  
  const searchNameserver = (e) => {
    e.preventDefault();
    setLoading(true);
    setFetched(false);
    setAlertMsg("");
    
    axios
      .post(
        "https://www.clubhosty.com/ns.php",
        {
          domain: e.target.domain.value,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((res) => {
        setLoading(false);
        
        // Handle new standardized API response
        if (res.data.success) {
          setData(res.data.data);
          setAlertMsg("");
          
          setTimeout(() => {
            scrollToElementRef?.current?.scrollIntoView({
              behavior: "smooth",
            });
          }, 100);
        } else {
          setAlertMsg(res.data.message || "An error occurred while looking up the nameserver.");
          setData(null);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setAlertMsg("An error occurred while looking up the nameserver. Please try again.");
        setData(null);
      });
  };

  const copyToClipboard = async (text, toastMessage) => {
    console.log("Attempting to copy text:", text); // Debug log
    
    if (!text || text.trim() === '') {
      showToast("Nothing to copy");
      return false;
    }
    
    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Use modern Clipboard API
        await navigator.clipboard.writeText(text);
        showToast(toastMessage);
        return true;
      } else {
        // Fallback method using textarea
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          if (successful) {
            showToast(toastMessage);
            return true;
          } else {
            throw new Error('execCommand copy failed');
          }
        } catch (err) {
          document.body.removeChild(textArea);
          throw err;
        }
      }
    } catch (err) {
      console.error('Failed to copy:', err);
      showToast("Failed to copy to clipboard");
      return false;
    }
  };

  const copyServerName = async () => {
    const element = serverNameRef.current;
    const text = element?.textContent || element?.innerText || data?.name || '';
    console.log("Copying server name:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Server name copied to clipboard!");
    if (success) {
      setTickServerName(true);
      setTimeout(() => {
        setTickServerName(false);
      }, 1000);
    }
  };
  
  const copyipName = async () => {
    const element = ipRef.current;
    const text = element?.textContent || element?.innerText || data?.ipaddress || '';
    console.log("Copying IP:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "IP address copied to clipboard!");
    if (success) {
      setTickIpName(true);
      setTimeout(() => {
        setTickIpName(false);
      }, 1000);
    }
  };
  
  const copyHostName = async () => {
    const element = hostnameRef.current;
    const text = element?.textContent || element?.innerText || data?.hostname || '';
    console.log("Copying hostname:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Hostname copied to clipboard!");
    if (success) {
      setTickHostName(true);
      setTimeout(() => {
        setTickHostName(false);
      }, 1000);
    }
  };
  
  const nameserver1 = async () => {
    const element = nameserver1Ref.current;
    const text = element?.textContent || element?.innerText || data?.nameserver1 || '';
    console.log("Copying nameserver1:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Nameserver 1 copied to clipboard!");
    if (success) {
      setnameserver1Name(true);
      setTimeout(() => {
        setnameserver1Name(false);
      }, 1000);
    }
  };
  
  const nameserver2 = async () => {
    const element = nameserver2Ref.current;
    const text = element?.textContent || element?.innerText || data?.nameserver2 || '';
    console.log("Copying nameserver2:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Nameserver 2 copied to clipboard!");
    if (success) {
      setnameserver2Name(true);
      setTimeout(() => {
        setnameserver2Name(false);
      }, 1000);
    }
  };
  
  const nameserver3 = async () => {
    const element = nameserver3Ref.current;
    const text = element?.textContent || element?.innerText || data?.nameserver3 || '';
    console.log("Copying nameserver3:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Nameserver 3 copied to clipboard!");
    if (success) {
      setnameserver3Name(true);
      setTimeout(() => {
        setnameserver3Name(false);
      }, 1000);
    }
  };
  
  const nameserver4 = async () => {
    const element = nameserver4Ref.current;
    const text = element?.textContent || element?.innerText || data?.nameserver4 || '';
    console.log("Copying nameserver4:", text, "Element:", element); // Debug log
    const success = await copyToClipboard(text, "Nameserver 4 copied to clipboard!");
    if (success) {
      setnameserver4Name(true);
      setTimeout(() => {
        setnameserver4Name(false);
      }, 1000);
    }
  };

  useEffect(() => {
    console.log(data);
    console.log(alertMsg);
    
    if (data && data.name) {
      setFetched(true);
      setTimeout(() => {
        scrollToElementRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else if (alertMsg) {
      setFetched(false);
      setTimeout(() => {
        scrollToElementRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [data, alertMsg]);
  return (
    <>
      <Helmet>
        <title>NameServer Lookup » ClubHosty</title>
        <link rel="canonical" href="https://www.clubhosty.com/nameserver" />
        <meta name="description" content="Free DNS nameserver lookup tool to find domain name servers instantly. Check DNS records and nameserver information for any domain." />
      </Helmet>
      
      <div className="nameserver-container">
        {/* Main Content Section */}
        <section className="main-content">
          <div className="container">
            <div className="content-header">
              <h1 className="main-title">Can't find your nameserver?</h1>
              <p className="main-subtitle">Follow the simple steps</p>
            </div>

            {/* Steps Section */}
            <div className="steps-container">
              <div className="step-card">
                <div className="step-number">1</div>
                <div className="step-content">
                  <p>Enter Your <strong>Primary Domain</strong> of cPanel in Search Box below</p>
                </div>
              </div>
              
              <div className="step-card" ref={scrollToElementRef}>
                <div className="step-number">2</div>
                <div className="step-content">
                  <p>Click on Search!</p>
                </div>
              </div>
              
              <div className="step-card">
                <div className="step-number">3</div>
                <div className="step-content">
                  <p>BOOM!! Get Your Nameservers.</p>
                </div>
              </div>
            </div>

            <div className="note-section">
              <p><strong>Note:</strong> You can contact your domain registrar support to add/update our nameservers.</p>
            </div>

            {/* Error Alert */}
            {alertMsg && (
              <div className="alert-message">
                <ErrorOutlineIcon className="alert-icon" />
                <span>{alertMsg}</span>
              </div>
            )}
          </div>
        </section>

        {/* Search Section */}
        <section className="search-section">
          <div className="container">
            <form className="search-form" onSubmit={searchNameserver} method="post">
              <div className="search-container">
                <input
                  type="text"
                  placeholder="Enter Domain Name here to Find Nameservers"
                  className="search-input"
                  name="domain"
                  required
                />
                <button type="submit" className="search-button" disabled={loading}>
                  {loading ? (
                    <>
                      <div className="loading-spinner"></div>
                      <span>Searching...</span>
                    </>
                  ) : (
                    <span>Search!</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </section>

        {/* Loading Section */}
        {loading && (
          <section className="loading-section">
            <div className="container">
              <div className="loading-content">
                <div className="loading-animation">
                  <DnsIcon className="loading-icon" />
                  <div className="loading-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <h3 className="loading-title">Searching DNS Records...</h3>
                <p className="loading-text">
                  We're looking up nameserver information for your domain. This may take a few seconds.
                </p>
              </div>
            </div>
          </section>
        )}

        {/* Results Section */}
        {fetched && (
          <section className="results-section">
            <div className="container">
              <div className="results-header">
                <div className="results-badge">
                  <DnsIcon className="results-badge-icon" />
                  <span>DNS Information</span>
                </div>
                <h2 className="results-title">
                  Your <span className="highlight">Name Servers</span> Found!
                </h2>
                <p className="results-subtitle">
                  Here's the complete DNS information for your domain
                </p>
              </div>

              {/* Server Details */}
              <div className="server-details">
                <h3 className="details-title">Server Information</h3>
                <div className="details-grid">
                  <div className="detail-card" onClick={copyServerName}>
                    <div className="detail-header">
                      <span className="detail-label">Server Name</span>
                      <div className="copy-indicator">
                        {tickServerName ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                    <div className="detail-value" ref={serverNameRef}>
                      {data?.name}
                    </div>
                  </div>

                  <div className="detail-card" onClick={copyipName}>
                    <div className="detail-header">
                      <span className="detail-label">IP Address</span>
                      <div className="copy-indicator">
                        {tickIpName ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                    <div className="detail-value" ref={ipRef}>
                      {data?.ipaddress}
                    </div>
                  </div>

                  <div className="detail-card" onClick={copyHostName}>
                    <div className="detail-header">
                      <span className="detail-label">Hostname</span>
                      <div className="copy-indicator">
                        {tickHostName ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                    <div className="detail-value" ref={hostnameRef}>
                      {data?.hostname}
                    </div>
                  </div>
                </div>
              </div>

              {/* Nameservers */}
              <div className="nameservers-section">
                <h3 className="nameservers-title">Domain Nameservers</h3>
                <div className="nameservers-grid">
                  {data?.nameserver1 && (
                    <div className="nameserver-card" onClick={nameserver1}>
                      <div className="nameserver-icon">
                        <DnsIcon />
                      </div>
                      <div className="nameserver-content">
                        <div className="nameserver-label">Primary NS</div>
                        <div className="nameserver-value" ref={nameserver1Ref}>
                          {data.nameserver1}
                        </div>
                      </div>
                      <div className="nameserver-action">
                        {nameserver1Name ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                  )}

                  {data?.nameserver2 && (
                    <div className="nameserver-card" onClick={nameserver2}>
                      <div className="nameserver-icon">
                        <DnsIcon />
                      </div>
                      <div className="nameserver-content">
                        <div className="nameserver-label">Secondary NS</div>
                        <div className="nameserver-value" ref={nameserver2Ref}>
                          {data.nameserver2}
                        </div>
                      </div>
                      <div className="nameserver-action">
                        {nameserver2Name ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                  )}

                  {data?.nameserver3 && (
                    <div className="nameserver-card" onClick={nameserver3}>
                      <div className="nameserver-icon">
                        <DnsIcon />
                      </div>
                      <div className="nameserver-content">
                        <div className="nameserver-label">Tertiary NS</div>
                        <div className="nameserver-value" ref={nameserver3Ref}>
                          {data.nameserver3}
                        </div>
                      </div>
                      <div className="nameserver-action">
                        {nameserver3Name ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                  )}

                  {data?.nameserver4 && (
                    <div className="nameserver-card" onClick={nameserver4}>
                      <div className="nameserver-icon">
                        <DnsIcon />
                      </div>
                      <div className="nameserver-content">
                        <div className="nameserver-label">Quaternary NS</div>
                        <div className="nameserver-value" ref={nameserver4Ref}>
                          {data.nameserver4}
                        </div>
                      </div>
                      <div className="nameserver-action">
                        {nameserver4Name ? (
                          <CheckCircle className="copied-icon" />
                        ) : (
                          <ContentCopyIcon className="copy-icon" />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}
      </div>

      {/* Toast Notification */}
      {toastMessage && (
        <div className="toast-notification">
          <CheckCircle className="toast-icon" />
          <span>{toastMessage}</span>
        </div>
      )}
    </>
  );
}

export default NameServer;
